import Guild from '@/views/Detail/Guild.vue'

const routes = [
    {
        path:'/gremios/:id',
        name: 'guild_detail',
        component:Guild,
        meta: {
          title: route => { return `Gremio ${route.params.id.toUpperCase()} ༒ MUCRISIS`},
          layout: 'default',
          metaTags: [
            {
              name: 'description',
              content: route => { return `Ven y conoce todo sobre el gremio ${route.params.id.toUpperCase()} y sus miembros actuales! MUCRISIS siempre a la vanguardia.`}
            },
            {
              property: 'og:description',
              content: route => { return `Ven y conoce todo sobre el gremio ${route.params.id.toUpperCase()} y sus miembros actuales! MUCRISIS siempre a la vanguardia.`}
            }
          ]
        }
    },
]

export default routes